// extracted by mini-css-extract-plugin
export default {"message":"validation-message_message__D5iOm"};